import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CandidateDetailsFormData } from "../validation";
import { FormSelect, FormTextField, HeaderDivider } from "components";
import { Alert, Grid } from "@mui/material";

export const PermissionToLeave = ({
  control,
}: {
  control: Control<CandidateDetailsFormData>;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <HeaderDivider
        text={t("details.permissionToLeaveTitle")}
        sx={{ mb: 3 }}
      />
      <Grid container spacing={2} sx={{ mb: 8 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormSelect
            name="permissionToLeave.canLeave"
            label={t("details.permissionToLeave.canLeave.label")}
            placeholder={t("details.permissionToLeave.canLeave.placeholder")}
            options={[
              {
                value: true,
                label: t("details.permissionToLeave.canLeave.yes"),
              },
              {
                value: false,
                label: t("details.permissionToLeave.canLeave.no"),
              },
            ]}
            control={control}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="permissionToLeave.guardianName"
            label={t("details.permissionToLeave.guardian.label")}
            placeholder={t("details.permissionToLeave.guardian.placeholder")}
            control={control}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="permissionToLeave.guardianPhone"
            label={t("details.permissionToLeave.guardianPhone.label")}
            placeholder={t(
              "details.permissionToLeave.guardianPhone.placeholder"
            )}
            control={control}
            type="phone"
            required
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="permissionToLeave.personCollectingCandidate"
            label={t(
              "details.permissionToLeave.personCollectingCandidate.label"
            )}
            placeholder={t(
              "details.permissionToLeave.personCollectingCandidate.placeholder"
            )}
            control={control}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <Alert severity="info">
            {t("details.permissionToLeave.superMinorHintText")}
            <br />
            <br />
            {t("details.permissionToLeave.minorHintText")}
          </Alert>
        </Grid>
      </Grid>
    </>
  );
};
